import { IsEmail, IsOptional, IsString } from 'class-validator';

export class SendEmailDto {
	@IsEmail()
	to: string;

	@IsString()
	subject: string;

	@IsString()
	body: string;
}

export class SendWaitlistNotifyDto {
	@IsString()
	eventId: string;

	@IsOptional()
	@IsString()
	waitlistId?: string;
}
